import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UserManagmentService } from '../../user-managment.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@root/common/confirmation-dialog/confirmation-dialog.component';
@Component({
  selector: 'app-region-list',
  templateUrl: './region-list.component.html',
  styleUrls: ['./region-list.component.scss'],
  providers: [UserManagmentService]
})
export class RegionListComponent implements OnInit {

  regionList: [];

  searchByName: string;

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() regionChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(public userManagmentService: UserManagmentService,
              private errorHandler: ErrorHandler,
              private toastr: ToastrService,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.readRegion();
  }

  public readRegion(){
    this.userManagmentService.getRegionList().subscribe(
      response => {
        if(response.status === 0){
          this.regionList = response.data.list;
          this.regionChange.emit(this.regionList)
        }else{
          this.errorHandler.handleError(response);
        }
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public openDeleteDialog(role) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: role , mode: 'REGION-DELETE'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.userManagmentService.deleteRegion({ regionId: result.data.regionId }).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readRegion();
            } else {
              this.toastr.error(response.error.errorMessage);
            }
          },
          (error) => {
            this.toastr.error(error.errorMessage);
            
          }
        );
      }
    });
  }

  onEditRegion(obj: any) {
    let selectedRegion = {id:obj.id, name:"", regionId:obj.regionId};
    selectedRegion['name']=obj["regionName"];
    this.editChange.emit(selectedRegion);
    this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

}
